<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Adjust Log Summary" class="user-list-filters mb-8" :collapse-action="true">
      <RawMaterialAdjustStockLogSummary/>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="RAW MATERIAL STOCK" v-can="'view-raw-material-stock-inventory'">
          <template slot="actions">
            <vs-button @click.stop="onClickDownloadFullSheet()" class="mr-4 mb-4" color="primary" type="filled">Download Stock Inventory Audit Log</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="raw-material-stock-table" max-items="10" :data="staff"  sort  stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" class="text-xs" sort-key="company_product_code">BATCH</vs-th>
                <vs-th width="15%" class="text-xs" sort-key="company_product_name">ITS Product Code</vs-th>
                <vs-th width="15%" class="text-xs" sort-key="company_product_name">ITS Product Name</vs-th>
                <vs-th width="20%" class="text-xs" sort-key="supplier_product_code">Available Qty (Kg)</vs-th>
                <vs-th width="15%" class="text-xs" sort-key="supplier_product_name">Completed Qty (Kg)</vs-th>
                <vs-th width="10%" class="text-xs" sort-key="country_processing">Manufacturing Date</vs-th>
                <vs-th width="10%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewRmStock(tr.id)" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].batch_no">
                    {{ data[indextr].batch_no }}
                  </vs-td>
                  <vs-td :data="data[indextr].category">
                    {{ data[indextr].category }} - {{data[indextr].company_product_code  }}
                  </vs-td>
                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].company_product_name ?data[indextr].company_product_name : '-' }}
                  </vs-td>
                  <vs-td :data="data[indextr].available_quantity">
                    {{ Number(data[indextr].available_quantity).toFixed(2) }}
                  </vs-td>
                  <vs-td :data="data[indextr].total_quantity">
                    {{ Number(data[indextr].total_quantity).toFixed(2) }}
                  </vs-td>
                  <vs-td :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date }}
                  </vs-td>


                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Log" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickViewRmStock(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Download Log" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickDownloadSheet(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <raw-material-stock-adjust-log-popup ref="rawMaterialStockAdjustLogPopup"/>
    <download-inventory-log-pop-up ref="downloadInventoryLogPopUp"/>
    <DownloadInventoryChangeLogPopUp ref="downloadInventoryChangeLogPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import {defaultPagination, perPageList} from "@/constants/config";
  import RawMaterialStockAdjustLogPopup
    from "@/components/popups/activity-logs/stock-adjust/RawMaterialStockAdjustLogPopup";
  import DownloadInventoryLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryLogPopUp.vue';
  import DownloadInventoryChangeLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryChangeLogPopUp.vue';
  import RawMaterialAdjustStockLogSummary from './RawMaterialAdjustStockLogSummary.vue';

  export default {
    name: 'RawMaterialAllBatchList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      RawMaterialStockAdjustLogPopup,
      DownloadInventoryLogPopUp,
      DownloadInventoryChangeLogPopUp,
      RawMaterialAdjustStockLogSummary
    },
    mixins : [Filter],
    methods: {
      async refreshData () {
        this.loadStaff()
      },
      async loadStaff() {
        await this.$vs.loading({
          container: '#raw-material-stock-table',
          scale: 0.45
        })
        this.supplierId = this.$route.params.id
        const {data} = await ManufacturingRepository.getRawMaterialStock(this.page, this.filterQuery, this.perPage, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#raw-material-stock-table > .con-vs-loading')
      },
      async onClickViewRmStock(id) {
        await this.$refs.rawMaterialStockAdjustLogPopup.openPopup(id)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },
      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },
      onClickDownloadSheet(id) {
        this.$refs.downloadInventoryLogPopUp.openPopup(id, 'raw-material-inventory')
      },
      async onClickDownloadFullSheet() {
        this.$refs.downloadInventoryChangeLogPopUp.openPopup('raw-material-inventory')
      },
    },
    watch : {
      page(){
        this.loadStaff()
      },
      perPage() {
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>

</style>
